import { render, staticRenderFns } from "./waitConfirmTrash.vue?vue&type=template&id=95a7c166"
import script from "./waitConfirmTrash.vue?vue&type=script&lang=js"
export * from "./waitConfirmTrash.vue?vue&type=script&lang=js"
import style0 from "./waitConfirmTrash.vue?vue&type=style&index=0&id=95a7c166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports